import { FaCheckCircle } from "react-icons/fa";
import Commercial from "../assets/images/office_2.jpg";
import image_gobies from "../assets/images/landing.jpg";
import Residental from "../assets/images/residential.jpg";
import { useTranslation } from "react-i18next";

const CleaningSolutions = () => {
    const { t } = useTranslation();
  return (
    <section id="solution" className="relative bg-white lg:py-14 py-8 px-[20px] lg:px-20 xl:px-30 2xl:px-80">
      <div className=" relative z-10 mx-auto flex flex-col lg:flex-row items-center gap-8 ">
                {/* Imagen principal con dos imágenes flotantes */}
                <div className="relative w-full lg:w-1/2 lg:h-[550px] h-[240px] flex justify-center items-center">
                    <img
                        src={image_gobies}
                        alt="Cleaning Service"
                        className="rounded-lg shadow-lg h-full object-cover mx-auto w-[350px]"
                    />
                    <img
                        src={Commercial}
                        alt="Detail 1"
                        className="hidden lg:block absolute top-14 left-24 rounded-lg shadow-lg border-4 border-white w-[140px] h-[200px] object-cover "
                    />
                    <img
                        src={Residental}
                        alt="Detail 2"
                        className="hidden lg:block absolute bottom-14 right-24 rounded-lg shadow-lg border-4 border-white w-[140px] h-[200px] object-cover"
                    />
                </div>

                        {/* Texto y lista de servicios */}
                        <div className="w-full lg:h-[550px] lg:w-[60%] flex flex-col justify-start">
                        <h2 className="text-[22px] lg:text-[32px] font-bold text-textTitle mb-2 lg:mb-4">
                           {t("frecuence.frecuence-title")}
                        </h2>
                        <p className="text-textSubtitle font-medium text-[12px] lg:text-[14px] leading-[20px] lg:leading-[28px] mb-6">
                        {t("frecuence.frecuence-description")}
                        </p>

                        <ul className="space-y-4">
                            <li className="flex items-start">
                            <FaCheckCircle className="text-yellow-400  w-6 h-6 mr-4" />
                            <div>
                                <h4 className="lg:text-[14px] text-[12px] font-semibold">{t("frecuence.One-Time Service")}</h4>
                                <p className="text-gray-600 lg:text-[14px] text-[12px]">
                                {t("frecuence.One-Time Service description")}
                                </p>
                            </div>
                            </li>
                            <li className="flex items-start">
                            <FaCheckCircle className="text-yellow-400  w-6 h-6 mr-4" />
                            <div>
                                <h4 className="lg:text-[14px] text-[12px]  font-semibold">{t("frecuence.Recurring Service")}</h4>
                                <p className="text-gray-600 lg:text-[14px] text-[12px]">
                                {t("frecuence.Recurring Service description")}
                                </p>
                            </div>
                            </li>
                            <li className="flex items-start">
                            <FaCheckCircle className="text-yellow-400 w-6 h-6 mr-4" />
                            <div>
                                <h4 className="lg:text-[14px] text-[12px]  font-semibold">{t("frecuence.Deep Cleaning")}</h4>
                                <p className="text-gray-600 lg:text-[14px] text-[12px]">
                                {t("frecuence.Deep Cleaning description")}
                                </p>
                            </div>
                            </li>
                            <li className="flex items-start">
                            <FaCheckCircle className="text-yellow-400  w-6 h-6 mr-4" />
                            <div>
                                <h4 className="lg:text-[14px] text-[12px]  font-semibold">{t("frecuence.Special Services")}</h4>
                                <p className="text-gray-600 lg:text-[14px] text-[12px]">
                                {t("frecuence.Special Services description")}
                                </p>
                            </div>
                            </li>
                        </ul>
                        </div>
       
      </div>
       {/* Eslogan en el fondo azul */}
       <div className="hidden 2xl:flex absolute lg:bottom-[40px] bottom-[50px] z-0 left-0 right-0 bg-bgPrimary text-white lg:h-[100px] h-[60px] px-[20px] lg:px-80  items-center justify-center lg:justify-end">
          <p className="text-xl font-semibold my-auto">{t("frecuence.live")} – {t("frecuence.work")}</p>
        </div>
    </section>
  );
};

export default CleaningSolutions;
